import {
  EditBase,
  Form,
  useNotify,
  useRecordContext,
  useRedirect,
  useTranslate,
} from "ra-core";
import { Link } from "react-router";
import { DeleteButton } from "@/components/admin/delete-button";
import { buttonVariants } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

import { FormToolbar } from "../layout/FormToolbar";
import { CanDelete } from "../misc/CanDelete";
import type { Lead } from "../types";
import { LeadInputs } from "./LeadInputs";
import { leadRepresentation } from "./sources";

export const LeadEdit = ({ open, id }: { open: boolean; id?: string }) => {
  const redirect = useRedirect();
  const notify = useNotify();
  const close = () =>
    redirect("/leads", undefined, undefined, undefined, {
      _scrollToTop: false,
    });

  return (
    <Dialog open={open} onOpenChange={() => close()}>
      <DialogContent className="lg:max-w-3xl overflow-y-auto max-h-9/10 top-1/20 translate-y-0">
        {id ? (
          <EditBase
            id={id}
            resource="leads"
            mutationMode="pessimistic"
            mutationOptions={{
              onSuccess: () => {
                notify("resources.leads.updated");
                redirect(`/leads/${id}/show`, undefined, undefined, undefined, {
                  _scrollToTop: false,
                });
              },
            }}
          >
            <EditHeader />
            <Form>
              <LeadInputs />
              <FormToolbar />
            </Form>
          </EditBase>
        ) : null}
      </DialogContent>
    </Dialog>
  );
};

const EditHeader = () => {
  const translate = useTranslate();
  const lead = useRecordContext<Lead>();
  if (!lead) return null;
  return (
    <DialogTitle className="pb-0">
      <div className="flex flex-wrap justify-between items-start gap-2 pr-10">
        <h2 className="text-xl font-semibold min-w-0 break-words">
          {leadRepresentation(lead)}
        </h2>
        <div className="flex gap-2">
          <CanDelete resource="leads">
            <DeleteButton />
          </CanDelete>
          <Link
            to={`/leads/${lead.id}/show`}
            className={buttonVariants({ variant: "outline" })}
          >
            {translate("resources.leads.action.back")}
          </Link>
        </div>
      </div>
    </DialogTitle>
  );
};
